<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import PromotionCard from '../components/PromotionCard.svelte';

  let promotions = [];
  let isLoading = true;
  let error = '';
  let currentUser = null;

  onMount(async () => {
    const unsubscribe = authStore.subscribe(value => {
      currentUser = value.user;
    });

    if (currentUser) {
      await fetchUserPromotions();
    } else {
      // Handle case where user is not logged in
      isLoading = false;
    }
    
    return unsubscribe;
  });

  async function fetchUserPromotions() {
    isLoading = true;
    error = '';
    try {
      const userId = currentUser?.idTokenClaims?.oid;
      if (!userId) {
        throw new Error("User ID not found. Please log in again.");
      }

      const response = await fetch(getApiUrl(`/promotions/user/${userId}`));
      if (!response.ok) {
        throw new Error('Failed to fetch your promotions.');
      }
      promotions = await response.json();
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }
</script>

<div class="my-promotions-container">
  <h2>My Promotions</h2>
  <p>This page lists all the promotions you have created, with the most recently updated shown first.</p>

  {#if isLoading}
    <p>Loading your promotions...</p>
  {:else if error}
    <p class="error">{error}</p>
  {:else if promotions.length === 0}
    <p>You have not created any promotions yet.</p>
  {:else}
    <div class="promo-list">
      {#each promotions as promo (promo._id)}
        <PromotionCard {promo} />
      {/each}
    </div>
  {/if}
</div>

<style>
  .my-promotions-container {
    max-width: 1200px;
    margin: 2rem auto;
  }
  .promo-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
  }
  .error {
    color: red;
    font-weight: bold;
  }
</style>
